import "./FigmaPreview.scss";

export default {
  props: {
    file: Object,
  },
};
